var map = {
	"./agma2015-2-B15_fig01_radial-composite-deviation-50z.png": "2e68",
	"./agma2015-2-B15_fig02_agma-classification-specification.png": "4816",
	"./agma2015-2-B15_fig03_agma-classification-individual-tols.png": "690a",
	"./agma2015-2-B15_fig04_agma-classification-individual-vals.png": "2108",
	"./agma2015-2-B15_figB01_radial-composite-deviation-50z-4k.png": "324a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9ab7";